import { render, staticRenderFns } from "./FBlockList.vue?vue&type=template&id=6d1bd0e0&scoped=true&"
import script from "./FBlockList.vue?vue&type=script&lang=js&"
export * from "./FBlockList.vue?vue&type=script&lang=js&"
import style0 from "./FBlockList.vue?vue&type=style&index=0&id=6d1bd0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1bd0e0",
  null
  
)

export default component.exports